// import config from "./config.js";
import { fdbCrudUtils } from "./fdb-crud-utils.js";
// import { js_utils } from "./frfr-js-utils.js";
import { backendUtilsGenusCountersUpdateAndGetId, _backendUtilsVirtelGenusUpdateSmart, _entityVirtelInstance, _entityVirtelInstanceStandalone, _entityVirtelUni } from "../ter/ter-backend-utils.js";
import { virtel_schema_smart_get } from "../ter/ter-virtel-definition-lib.js";


// const databaseVersion = config.versions.databaseVersion;
const databaseVersion = 'structure2023-09-30r1';


const initalUsers = [
  {
    id: 1,
    username: 'admin',
    password: 'admin',
    display_name: 'admin',
    avatar_src: null,
    avatar_initials: 'ADM',
    activated: true,
    type: 'FIXED',
    role: 'ADMIN'
  },
  {
    id: 2,
    username: 'dev',
    password: 'dev',
    display_name: 'dev',
    avatar_src: null,
    avatar_initials: 'DEV',
    activated: true,
    type: 'FIXED',
    role: 'DEV',
  },
  {
    id: 3,
    username: 'tester',
    password: 'tester',
    display_name: 'tester',
    avatar_src: null,
    avatar_initials: 't',
    activated: true,
    type: 'FIXED',
    role: 'TESTER',
  },
  /*
  {
    id: 3,
    username: 'inzenjer',
    password: '',
    display_name: 'inzenjer',
    avatar_src: null,
    avatar_initials: '',
    activated: true,
    type: 'REGISTERED',
    role: 'ING',
  },
  */
  /*
  {
    id: 20,
    username: 'dusan.lazovic',
    password: 'Termo123',
    password_hash: '',
    email: 'dusan.lazovic@termovent.rs',
    display_name: 'Dušan Lazović',
    avatar_src: null,
    avatar_initials: 'DL',
    activated: true,
    type: 'REGISTERED',
    role: 'ADMIN',
  },
  {
    id: 31,
    username: 'andreja.stevanovic',
    password: 'Termo123',
    password_hash: '',
    email: 'andreja.stevanovic@termovent.rs',
    display_name: 'Andreja Stevanović',
    avatar_src: null,
    avatar_initials: 'AS',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 32,
    username: 'ivan.jankovic',
    password: 'Termo123',
    password_hash: '',
    email: 'ivan.jankovic@termovent.rs',
    display_name: 'Ivan Janković',
    avatar_src: null,
    avatar_initials: 'IJ',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 33,
    username: 'ivana.belic',
    password: 'Termo123',
    password_hash: '',
    email: 'ivana.belic@termovent.rs',
    display_name: 'Ivana Belić',
    avatar_src: null,
    avatar_initials: 'IB',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
    readme: 'moze da menja projekte'
  },
  {
    id: 34,
    username: 'nemanja.jankovic',
    password: 'Termo123',
    password_hash: '',
    email: 'nemanja.jankovic@termovent.rs',
    display_name: 'Nemanja Jankovic',
    avatar_src: null,
    avatar_initials: 'NJ',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 35,
    username: 'nikola.milenkovic',
    password: 'Termo123',
    password_hash: '',
    email: 'nikola.milenkovic@termovent.rs',
    display_name: 'Nikola Milenkovic',
    avatar_src: null,
    avatar_initials: 'NM',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 36,
    username: 'snezana.cirkovic',
    password: 'Termo123',
    password_hash: '',
    email: 'snezana.cirkovic@termovent.rs',
    display_name: 'Snežana Ćirković',
    avatar_src: null,
    avatar_initials: 'SĆ',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 37,
    username: 'zeljko.mladenovic',
    password: 'Termo123',
    password_hash: '',
    email: 'zeljko.mladenovic@termovent.rs',
    display_name: 'Željko Mladenović',
    avatar_src: null,
    avatar_initials: 'ŽM',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  {
    id: 38,
    username: 'zlatko.stingic',
    password: 'Termo123',
    password_hash: '',
    email: 'zlatko.stingic@termovent.rs',
    display_name: 'Zlatko Stingić',
    avatar_src: null,
    avatar_initials: 'ZS',
    activated: true,
    type: 'REGISTERED',
    role: 'USER',
  },
  */
];


// inicijalni sadrzaj baze
const initialDb = {
  counter: 102,
  meta: {
    name: 'sastavljac_app_fdb',
    readme: 'frontend FDB baza za termovent demo app 2023',
    db_structure_version: databaseVersion
  },
  collections: {
    tabela1: [{
      _id: 123
    }],
    db_meta: [
      {
        key: 'name',
        val: 'sastavljac_app_fdb'
      },
      {
        key: 'db_structure_version',
        val: databaseVersion
      },
      {
        key: 'description',
        val: 'frontend FDB baza za termovent demo app'
      }
    ],
    user: initalUsers,
    auth_session: [],
    genus_counters: [{
      counter_id: 'genus_counters',
      counter_all: 0 // counteri za sve tipove genus identa
    }],

    comorder: [], // company orders
    comorditem: [], // company order items
    // virbom_header: [],
    virtel_genus: [],
    // virtel_instance: [],
    // virtel_standalone: [],
    //
    // virtel_uni: [], // NOVO sadrzi flag db_join_with_genus
    // MSM
    // comorditem_and_virbom_master: [], // NOVO // ZA SADA koristimo 'comorditem_and_virbom_master' tabelu istovremno kao _master i za virbom_header_rev i za virbom_members_rev
    // virtel_uni_master: [], // mozda ne treba jer ce mozda virbom_header da ujedno igra ulogu mastera
    //
    virbom_master: [], // ???
    virbom_header_rev: [], // virbom header revizija
    virbom_members_rev: [], // virbom members revizije
    //
    virbom_membersj_rev: [], // TODO
  }
};


export const mutatorZaInicijalniSeed = () => {
  // ne prima argumente jer popunjava bazu od nule
  return initialDb;
};


export const mutatorAuthSessionsCreate = (db, sesija) => {
  const entity = sesija;
  const tablename = 'auth_session';
  const newDb = fdbCrudUtils.create(entity, tablename, db);
  return newDb;
};

export const mutatorAuthSessionsDeleteByToken = (db, token) => {
  /*
  DOKUMENTACIJA:
  brise se samo po tokenu da bi se sprecilo da neko ko nije ulogovan i nema token izloguje nekog ko ima.
  */
  const tablename = 'auth_session';
  let new_table = db.collections[tablename].filter((ses) => {
    if (ses.token === token) {
      return false; // delete session from array
    }
    return true; // stay in array
  });
  const newDb = { ...db };
  newDb.collections[tablename] = new_table;
  newDb.counter++;
  return newDb;
};

export const mutatorAuthSessionsDeleteByUserId = (db, user_id) => {
  /*
  DOKUMENTACIJA:
  ovo je logout korisnika sa svih sesija (svih racunara, svih browsera).
  */
  const tablename = 'auth_session';
  let new_table = db.collections[tablename].filter((ses) => {
    if (ses.user_id === user_id) {
      return false; // delete session from array
    }
    return true; // stay in array
  });
  const newDb = { ...db };
  newDb.collections[tablename] = new_table;
  newDb.counter++;
  return newDb;
};

export const mutatorAuthSesijaDelete = (db, id) => {
  const tablename = 'auth_session';
  const newDb = fdbCrudUtils.delete_by_id(id, tablename, db);
  return newDb;
};


export const mutatorUserCreate = (db, user) => {
  user.type = 'REGISTERED';
  if (user.activated !== true) {
    user.activated = false;
  }
  const entity = user;
  const tablename = 'user';
  const newDb = fdbCrudUtils.create(entity, tablename, db);
  return newDb;
};


export const mutatorUserUpdate = (db, { entbox, id }) => {
  const entity = entbox;
  const tablename = 'user';
  const newDb = fdbCrudUtils.update(id, entity, tablename, db);
  return newDb;
};


export const mutatorComorderCreate = (db, comorder) => {
  const entity = comorder;
  const tablename = 'comorder';
  const newDb = fdbCrudUtils.create(entity, tablename, db);
  return newDb;
};

export const mutatorComorderFlagDeleted = (db, { id, user_deleted, datetime_deleted }) => {
  const tablename = 'comorder';
  const updated_properties = {
    flag_deleted: true,
    datetime_deleted,
    user_deleted
  };
  let new_table = db.collections[tablename].map((item) => {
    if (item.id === id) {
      return {
        ...item,
        ...updated_properties,
        id: item.id
      };
    }
    return item;
  });
  let newDb = { ...db };
  newDb.counter++;
  newDb.collections[tablename] = new_table;
  return newDb;
};

export const mutatorComorditemFlagDeleted = (db, { id, user_deleted, datetime_deleted }) => {
  const tablename = 'comorditem';
  const updated_properties = {
    flag_deleted: true,
    datetime_deleted,
    user_deleted
  };
  let new_table = db.collections[tablename].map((item) => {
    if (item.id === id) {
      return {
        ...item,
        ...updated_properties,
        id: item.id
      };
    }
    return item;
  });
  let newDb = { ...db };
  newDb.counter++;
  newDb.collections[tablename] = new_table;
  return newDb;
};

export const comboComorditemCreate_OLD = (db, virbom_header) => {
  const entity = virbom_header;
  const tablename = 'comorditem';
  // const newDb = fdbCrudUtils.create(entity, tablename, db);
  const _fdbCrudUtils_create = function (entity, tablename, db) {
    if (!Array.isArray(db.collections[tablename])) {
      db.collections[tablename] = []; // create table if not exist
    }
    let new_id = db.counter + 1;
    let new_entity = {
      ...entity,
      id: new_id
    }
    let newDb = {
      ...db,
      counter: new_id
    };
    newDb.collections[tablename].push(new_entity);
    // return newDb;
    return [newDb, new_entity];
  };
  const [newDb, new_entity] = _fdbCrudUtils_create(entity, tablename, db);
  // return newDb;
  return [newDb, new_entity];
};
//
export const comboComorditemCreate_2023 = (db, entbox) => {
  // NOVO 2023
  const entity = entbox;
  const tablename = 'comorditem';
  // const newDb = fdbCrudUtils.create(entity, tablename, db);
  const _fdbCrudUtils_create = (entity, tablename, db) => {
    if (!Array.isArray(db.collections[tablename])) {
      db.collections[tablename] = []; // create table if not exist
    }
    let new_id = db.counter + 1;
    // let new_id_2 = new_id + 1;
    let new_entity = {
      ...entity,
      id: new_id,
      // MSM
      flag_deleted: false
    }
    let newDb = {
      ...db,
      counter: new_id
    };
    newDb.collections[tablename].push(new_entity);
    /*
    // FIX istovremeno dodajemo i prvu reviziju
    const OF_ID = new_id;  // OF_ID koji je foreign key koji upucuje na ID mastera.
    const REV_ID = new_id_2;
    const {
      user_created,
      datetime_created
    } = virbom_header;
    newDb.collections.virbom_header_rev = _make_new_virbom_header_rev_entity(db.collections.virbom_header_rev, OF_ID, REV_ID, { user_created, datetime_created });
    */
    // return newDb;
    return [newDb, new_entity];
  };
  const [newDb, new_entity] = _fdbCrudUtils_create(entity, tablename, db);
  // return newDb;
  return [newDb, new_entity];
};
//
export const mutatorComorditemCreate = (db, virbom_header) => {
  const entity = virbom_header;
  const tablename = 'comorditem';
  const newDb = fdbCrudUtils.create(entity, tablename, db);
  return newDb;
};


export const mutatorComorderUpdate = (db, { comorder, id }) => {
  const entity = comorder;
  const tablename = 'comorder';
  const newDb = fdbCrudUtils.update(id, entity, tablename, db);
  return newDb;
};

export const mutatorComorditemUpdate = (db, { entbox, id }) => {
  const entity = entbox;
  const tablename = 'comorditem';
  const newDb = fdbCrudUtils.update(id, entity, tablename, db);
  return newDb;
};
export const comboComorditemUpdate = (db, { entbox, id }) => {
  const entity = entbox;
  const tablename = 'comorditem';
  const newDb = fdbCrudUtils.update(id, entity, tablename, db);
  const newEntity = {
    ...entity,
    id
  };
  return [newDb, newEntity];
};


// TODO virbom_header delete mora biti pazljivo osmisljen jer on mora da obrise i sve sirocice komore, module, i druge children koje pripadaju tom projektu.


// NOVO cuvanje drafta u bazu

const _enrichWithSuperkey = (arr, superkey) => {
  let wrappedArr = arr.map((item) => {
    item.superkey = superkey; // dodaje polje superkey (objedinjuje membere jednog virboma) na svaki item
    return item;
  });
  return wrappedArr;
};
const _removeItemsWhereSuperkey = (arr, superkey) => {
  // update veceg broja komora, modula, etc zahteva da se prethodni obrisu
  let newArr = arr.filter((item) => {
    if (item.superkey === superkey) {
      return false;
    }
    return true;
  });
  return newArr;
};

const _updateVirbomHeader = (arr, superkey, spread_me) => {
  // 
  let newArr = arr.map((item) => {
    if (item.id === superkey) {
      return {
        ...item,
        ...spread_me
      };
    }
    return item;
  });
  return newArr;
};


const _make_new_virbom_header_rev_entity = (of_id, rev_id, spread_me) => {
  // NOVO 2023
  const new_header_rev_entity = {
    // datetime_created: '',
    ...spread_me,
    id: rev_id, // ID koji je ujedno REV_ID (id revizije) koji u nekim slucajevima moze da zatreba da bi se naciljala bas ta konkretna revizija. Takodje sluzi da se pomocu njega odredi koja revizija je najnovija.
    of_id: of_id, // OF_ID koji je foreign key koji upucuje na ID mastera.
    superkey: rev_id, // ZA SADA OBA DA SE LAKSE POREDI (i vidi povezanost rev_id) SA virbom_members_rev
    flag_published: true, // FLAG_PUBLISHED koji sluzi za to da li se ova revizija racuna u potencijalne kandidate za najnoviju/zvanicnu/default reviziju.
    flag_deleted: false, // FLAG_DELETED koji sluzi da se ova revizija potpuno ignorise i znaci da je spremana za pravo brisanje.
    readme: "id je id revizije REV_ID"
  };
  // nisat ne brise iz tabele nego samo dodaje novu reviziju
  /*
  const newArr = [...arr, new_header_rev_entity];
  return newArr;
  */
  return new_header_rev_entity;
};


export const comboDraftUpdate = (db, { _virbom_header_of_id, virtel_with_genus_ident_arr, user_modified, datetime_modified }) => {
  // SUPERUPDATE WITH GENUS
  // NOVO 2021april
  let selected = null;

  let new_id = db.counter + 1;

  let new_instances = [];
  let new_standalones = []; // na primer klimakomore i moduli nemaju genuse i instance nego idu kao celoviti u jednu tabelu
  console.log(virtel_with_genus_ident_arr);
  if (Array.isArray(virtel_with_genus_ident_arr)) {
    virtel_with_genus_ident_arr.forEach((virtel) => {
      const sema = virtel_schema_smart_get(virtel.virtelschemakey);
      if (sema && sema.program && sema.program.use_genus === true) {
        const genus_ident = virtel.genus_ident;
        new_instances.push(_entityVirtelInstance(genus_ident, virtel)); // make backend instance
      } else {
        // ne pushujemo u instance one virtele koji nemaju use_genus
      }
      if (sema && sema.program && sema.program.use_classic_table === true) {
        // pushujemo u poseban niz one koji idu u standalone tabelu
        // new_standalones.push(virtel);
        // NOVO DECEMBAR sve instance idu u istu tabelu virtel_instance
        new_instances.push(_entityVirtelInstanceStandalone(virtel)); // make backend instance
      }
    });
  } else {
    console.warn('virtel_with_genus_ident_arr NOT ARRAY!!!');
  }
  console.log(new_instances); // db_virtel_arr

  selected = new_instances; // TODO: treba nesto drugo da vrati
  const superkey = _virbom_header_of_id;
  const newDb = {
    ...db,
    counter: new_id,
    collections: {
      ...db.collections,
      virbom_header: _updateVirbomHeader(db.collections.virbom_header, superkey, {
        user_created: user_modified,
        datetime_created: datetime_modified
      }),
      virtel_standalone: [..._removeItemsWhereSuperkey(db.collections.virtel_standalone, superkey), ..._enrichWithSuperkey(new_standalones, superkey)],
      virtel_instance: [..._removeItemsWhereSuperkey(db.collections.virtel_instance, superkey), ..._enrichWithSuperkey(new_instances, superkey)],
      test: 'ovo je test'
    }
  };
  console.log(newDb);
  console.log(selected);
  return [newDb, selected];
};


export const comboGenusUpdateSmart = (db, virtel) => {
  // COMBINED MUTATOR AND SELECTOR
  let selected = null;
  // NOVO 2021mart
  // dodavanje JEDNOG genusa (bilo da je deo virtuelnog drafta ili iz biblioteke direktno dodavanje)
  // ovaj se ne bavi instancama, samo kreira genuse i genus_ident, za instance koje ce biti uspisivane kasnije kroz neki drugi API poziv

  let _genus_counters = db.collections.genus_counters;
  const [new_genus_counters, new_id] = backendUtilsGenusCountersUpdateAndGetId(_genus_counters); // PRIVREMENO za sada ovo resenje ce da uvecavacounter cak i kad nije nov genus
  console.log('test COUNTER ', _genus_counters);
  console.log('test counter FRESH ID: ', new_id);

  // sledeci korak je da upravo kreiran id zajedno sa primljenim virtelom poslje funkciji koja ce da ga upise u genusa ako treba.
  const {
    genus_arr,
    genus_ident,
    is_updated
  } = _backendUtilsVirtelGenusUpdateSmart(db.collections.virtel_genus, virtel, new_id);
  selected = genus_ident;

  let newDb = false;
  if (is_updated === true) {
    // ako je potreban update stanja countera
    _genus_counters = new_genus_counters;
    newDb = {
      ...db,
      collections: {
        ...db.collections,
        genus_counters: _genus_counters,
        virtel_genus: genus_arr
      }
    };
    // console.log(genus_arr);
    // console.log(genus_ident);
  } else {
    // newDb = false; // mutator will not change db
  }
  return [newDb, selected];
};


export const comboDraftUpdateWithRevisions_2023 = (db, { virbom_parent_id, virtel_with_genus_ident_arr, user_modified, datetime_modified }) => {
  console.log('comboDraftUpdateWithRevisions_2023()');
  // NOVO 2023januar SUPERUPODATE BEZ GENUSA I SA REVIZIJAMA
  // RESENJE SA REVIZIJAMA niste se ne menja i ne brise samo se upisuju podaci o novoj reviziji.
  /*
  Taj virbom_parent_id je ID stavke narudzbe koja je parent od ovog virboma.
  */
  let selected = null;
  let new_uni = []; // unificirano i standalone i instance koje treba da budu join-ovane sa genisima
  console.log(virtel_with_genus_ident_arr);
  if (Array.isArray(virtel_with_genus_ident_arr)) {
    virtel_with_genus_ident_arr.forEach((virtel) => {
      const sema = virtel_schema_smart_get(virtel.virtelschemakey);
      // pushujemo sve u isti niz i one koje su sa genusima i standalone
      new_uni.push(_entityVirtelUni(virtel, null)); // make backend uni entity
    });
  } else {
    console.warn('virtel_with_genus_ident_arr NOT ARRAY!!!');
  }
  console.log(new_uni); // db_virtel_arr
  selected = new_uni; // TODO: treba nesto drugo da vrati
  const _enrichWithSuperkey_2023 = (arr, superkey) => {
    // NOVO 2023
    let wrappedArr = arr.map((item) => {
      item.superkey = superkey; // dodaje polje superkey (objedinjuje membere jednog virboma) na svaki item
      item.rev_id = superkey; // dodaje polje superkey (objedinjuje membere jednog virboma) na svaki item
      return item;
    });
    return wrappedArr;
  }
  const user_created = user_modified;
  const datetime_created = datetime_modified;
  //
  //
  let new_id = db.counter; // old counter
  let new_virbom_master_table = db.collections.virbom_master;
  let virbom_master_ = false;
  let of_id = false;
  db.collections.virbom_master.forEach((item) => {
    if (item.virbom_parent_id === virbom_parent_id) {
      virbom_master_ = item;
      of_id = item.id;
    }
  });
  if (of_id !== false && of_id > 0) {
    // Master already exist. Just create new revision
  } else {
    // create new master entity
    new_id = db.counter + 1;
    of_id = new_id;
    const new_virbom_master_entity = {
      id: of_id,
      virbom_parent_id: virbom_parent_id, // TODO ???
      virbom_parent_type: 'comorditem', // TODO ???
      /*
      virnadskup_id,
      virnadskup_type // TODO
      */
      user_created,
      datetime_created
    };
    new_virbom_master_table = [...db.collections.virbom_master, new_virbom_master_entity];
  }
  //
  //
  new_id = new_id + 1;
  const rev_id = new_id; // ujedno superkey za virbom members
  const selected_virbom = {};
  selected_virbom.virbom_header = _make_new_virbom_header_rev_entity(of_id, rev_id, { user_created, datetime_created });
  selected_virbom.virbom_members = _enrichWithSuperkey_2023(new_uni, rev_id);
  const newDb = {
    ...db,
    counter: new_id,
    collections: {
      ...db.collections,
      virbom_master: new_virbom_master_table,
      virbom_header_rev: [...db.collections.virbom_header_rev, selected_virbom.virbom_header],
      virbom_members_rev: [...db.collections.virbom_members_rev, ...selected_virbom.virbom_members],
      test: 'ovo je test'
    }
  };
  console.log(newDb);
  console.log(selected_virbom);
  return [newDb, selected_virbom]; // returnujemo novu reviziju virboma
};

